import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Paper, Stack, Typography } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useSnackbar } from 'notistack';

import { selectBrand } from '../store/settingsSlice';
import { isValidColor } from '../utils/Colors';

const defaultBrandColors = {
    quickverleih: "#70C1B3",
    edulendo: "#64a2bd",
};

export function useCartNotification() {
    const brand = useSelector(selectBrand);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const brandColor = window.appStyle?.primary && isValidColor(window.appStyle.primary)
        ? window.appStyle.primary
        : (defaultBrandColors[brand] || defaultBrandColors.quickverleih);

    const showItemAddedToCart = () => {
        enqueueSnackbar(t("cart.notification.itemAdded"), {
            preventDuplicate: true,
            anchorOrigin: { vertical: "bottom", horizontal: "center" },
            content: (snackbarId) => (
                <Paper
                    elevation={3}
                    sx={{
                        width: { xs: "calc(100vw - 32px)", sm: 420 },
                        maxWidth: "100%",
                        borderRadius: "12px",
                        border: "none",
                        px: 2,
                        py: 1.5,
                    }}
                >
                    <Stack direction="row" spacing={1.5} alignItems="center">
                        <ShoppingCartIcon sx={{ color: brandColor }} />
                        <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} alignItems={{ xs: "stretch", sm: "center" }} sx={{ flexGrow: 1 }}>
                            <Typography variant="body2" color="text.primary" sx={{ flexGrow: 1 }}>
                                {t("cart.notification.itemAdded")}
                            </Typography>
                            <Button
                                variant="contained"
                                size="small"
                                sx={{
                                    bgcolor: brandColor,
                                    boxShadow: "none",
                                    color: "#FAFAFA",
                                    fontSize: 12,
                                    fontWeight: 500,
                                    letterSpacing: "0.01px",
                                    textTransform: "uppercase",
                                    "&:hover": {
                                        bgcolor: brandColor,
                                        boxShadow: "none",
                                    },
                                }}
                                onClick={() => {
                                    closeSnackbar(snackbarId);
                                    navigate("/cart");
                                }}
                            >
                                {t("cart.notification.goToCart")}
                            </Button>
                        </Stack>
                    </Stack>
                </Paper>
            ),
        });
    };

    return {
        showItemAddedToCart,
    };
}
